import React from 'react';
import {useSelector} from 'react-redux';
import TopMenu from './components/top-menu';
import BottomMenu from './components/bottom-menu';
import './index.css';

function Menu ({extendMenu, extendHandler}) {

	const isMobileOrTabletDetected = useSelector( state => state.mobileReducer.isMobileOrTabletDetected);
	const sharingPageReady = useSelector(state => state.profileReducer.sharingPageReady);

	const removeAllExtended = () => {

		document.querySelectorAll('.extend').forEach( item => {
			item.classList.remove('extend');
		});

		if(extendHandler){
			extendHandler(false);
		}

	};

	const extendSubMenu = (e) => {
		if(isMobileOrTabletDetected){
			document.querySelectorAll('.submenu.extend').forEach( item => {
				item.classList.remove('extend');
			});

			e.currentTarget.nextElementSibling.classList.add('extend');
		} else {
			removeAllExtended()
		}
	};

	return (
		<div className={`menu${isMobileOrTabletDetected && extendMenu ? ' extend' : ''}`}>
			<TopMenu sharingPageReady={sharingPageReady} removeAllExtended={removeAllExtended} extendSubMenu={extendSubMenu}/>
			{ sharingPageReady && <BottomMenu/> }
		</div>
	)
}

export default Menu;
